import { render } from "./HomeView.vue?vue&type=template&id=4a97f06a&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=4a97f06a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a97f06a"]])

export default __exports__